// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip-module--tooltip--vn9hC","header":"Tooltip-module--header--xRx__","body":"Tooltip-module--body--Fv3A3","image":"Tooltip-module--image--MhjSh"};